import { useCopies } from "../../../../hooks/useCopies";
import classNames from "classnames";
import Icon from "../../../../../assets/icons";
import React from "react";
import { CustomRendererType } from "../types";
import DefaultAssetPreview from "../defaultAssetPreview";
import { DEFAULT_ASSET_CONFIG } from "../constants";
import { getAssetUploadRecommendedCopy } from "../util";
import Button from "../../../../components/button";
import ImageAspectRatioWarning from "../../aspectRatioWarning";

export default function DefaultAssetUIRenderer({ assetConfig = DEFAULT_ASSET_CONFIG, ...props }: CustomRendererType) {
  const copies = useCopies();
  const uploadedAssets = React.useMemo(() => {
    if (props.defaultAsset && props.uploadedAssets?.length === 0) {
      return [{ ...props.defaultAsset }];
    } else {
      return props.uploadedAssets;
    }
  }, [props.uploadedAssets, props.defaultAsset]);

  return (
    <div
      tabIndex={0}
      className={classNames("defaultAsset", {
        "defaultAsset--disabled": props.disabled
      })}>
      <div
        {...props.dropzoneState?.getRootProps()}
        className={classNames("defaultAsset--wrapper", {
          isDragActive: props.dropzoneState?.isDragActive,
          "defaultAsset--hasError": props.hasError
        })}>
        <input {...props.dropzoneState?.getInputProps()} />
        {uploadedAssets.length > 0 ? (
          uploadedAssets.map(asset => (
            <DefaultAssetPreview
              key={asset.id}
              asset={asset}
              config={assetConfig}
              removeHandler={asset.id !== props.defaultAsset?.id ? props.removeAsset : undefined}
              disabled={props.disabled}
              assetUploadType={props.assetUploadType}
              disableImagePreview={props.disableImagePreview}
            />
          ))
        ) : (
          <div className="defaultAsset--icon">
            <Icon.CloudUpload />
          </div>
        )}
        <div className="defaultAsset--content text-center">
          {uploadedAssets.length > 0 ? (
            <React.Fragment>
              {copies.get(props.browseUploadCustomCopyKey || "update.asset.info.msg")}
              <Button.Link label={copies.get("browse")} onClick={props.dropzoneState?.open} disabled={props.disabled} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              {copies.get(props.browseUploadCustomCopyKey || "upload.asset.info.msg")}
              <Button.Link label={copies.get("browse")} disabled={props.disabled} onClick={props.dropzoneState?.open} />
              <div className="noteBlock">
                {getAssetUploadRecommendedCopy({
                  copies,
                  config: assetConfig,
                  assetUploadType: props.assetUploadType,
                  customCopy: props.recommendedCustomCopy,
                  customCopyKey: props.recommendedCustomCopyKey
                })}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      {uploadedAssets?.filter(asset => asset.incorrectAspectRatio).length > 0 && <ImageAspectRatioWarning />}
    </div>
  );
}
